const autocompleteCalendarFilter = {
  sites: 'Sites',
  users: 'Responsáveis / Inspecionado por',
  equipments: 'Tipo de Equipamento',
  equipmentGroups: 'Grupo do Equipamento',
  serviceTypes: 'Tipo do Serviço',
  frequencies: 'Periodicidade',
  areas: 'Departamentos',
  company: 'Empresas Terceiras'

};

export default autocompleteCalendarFilter;
